export default function riskDirective() {
  return {
    template: require('./risk.html'),
    restrict: 'E',
    controller: 'RiskController',
    controllerAs: 'riskVM',
    bindToController: true,
    replace: true,
    scope: {
      riskDetail: '=',
      showAssetName: '<',
      showType: '<',
      isAssign: '=',
      tooltipAppendToSelector: '@',
      assignAsset: '<',
      isEditProcessDialog: '<',
      isApproveProcessDialog: '<',
      isPraProcessMain: '<',
      process: '<',
      asset: '<',
      isEditAssetDialog: '<',
      showControlCount: '<',
      showActionIcons: '<',
      riskType: '<',
      showBulkDelete: '<',
      showSyncAsset: '<',
      showSyncRisk: '<',
      showSyncRiskMain: '<',
      assetType: '<',
    },
  };
}
